import {Container} from "@mui/material";
import JourneySteps from "./JourneySteps";

export default function Survey() {
    return (
        <Container sx={{pt: 5, mb: 5}} maxWidth='md'>
            <JourneySteps/>
        </Container>
    )
}
